import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { loginMember, resetMemberPassword } from '../api/memberAuthService';
import '../styles/auth.css';

function MemberLogin() {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetSent, setResetSent] = useState(false);
  const navigate = useNavigate();
  const { orgId } = useParams();

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await loginMember(formData.email, formData.password, orgId);
      navigate(`/BespokeBridge/${orgId}/member/home`);
    } catch (err) {
      if (err.message?.includes('Access denied')) {
        setError(err.message);
      } else if (err.message?.includes('Member account not found')) {
        setError(err.message);
      } else if (err.code === 'auth/invalid-credential' || err.code === 'auth/wrong-password') {
        setError('Invalid email or password. Please try again.');
      } else if (err.code === 'auth/user-not-found') {
        setError('No account found with this email.');
      } else if (err.code === 'auth/too-many-requests') {
        setError('Too many failed attempts. Please try again later.');
      } else {
        setError(err.message || 'Login failed. Please check your credentials.');
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordReset = async () => {
    if (!formData.email) {
      setError('Please enter your email address first.');
      return;
    }
    try {
      await resetMemberPassword(formData.email);
      setResetSent(true);
      setError('');
    } catch {
      setError('Error sending password reset email. Please try again.');
    }
  };

  const orgDisplayName = orgId
    ? orgId.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
    : '';

  return (
    <div className="auth-container">
      <div className="auth-card">
        {/* Brand */}
        <div className="auth-brand">
          <h1 className="auth-brand-name">BespokeBridge</h1>
          <p className="auth-brand-tagline">Community Management Platform</p>
        </div>

        <h2 className="auth-title">Member Portal</h2>

        {resetSent && (
          <div className="auth-success">
            Password reset email sent. Please check your inbox.
          </div>
        )}

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="auth-field">
            <label htmlFor="email">Email Address</label>
            <input
              id="email"
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="your@email.com"
              required
              autoComplete="email"
            />
          </div>

          <div className="auth-field">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter your password"
              required
              autoComplete="current-password"
            />
          </div>

          <button type="submit" className="auth-submit-btn" disabled={loading}>
            {loading ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        <button
          type="button"
          className="auth-forgot-link"
          onClick={handlePasswordReset}
        >
          Forgot your password?
        </button>

        <p className="auth-footer">
          Member portal for <strong>{orgDisplayName || 'your organisation'}</strong>
          &nbsp;·&nbsp;Powered by <strong>BespokeBridge</strong>
        </p>
      </div>
    </div>
  );
}

export default MemberLogin;
